import dayjs from "dayjs";

export function parse_date_time(date: string, time: string):Date {
    let parsed_time = parse_time(time);
    let parsed_date = dayjs(date).hour(parsed_time.hour).minute(parsed_time.minute).second(parsed_time.second).millisecond(parsed_time.millisecond);
    return parsed_date.toDate();
}
export function parse_time(time: string):ParsedTime {
    let time_parts = time.split(':');
    let parsed_time = {
        hour: parseInt(time_parts[0]),
        minute: parseInt(time_parts[1]),
        second: 0,
        millisecond: 0
    };
    return parsed_time;
}

export interface ParsedTime {
    hour: number,
    minute: number,
    second: number,
    millisecond: number
}